<template>
    <v-card elevation="0">
        <v-card elevation="0" outlined width="100%">
            <v-card-actions class="ma-2 pa-0">
                <v-btn class="green white--text pr-5" elevation="0" @click="onPressCreate()"><v-icon class="mr-2">mdi-plus</v-icon>Create Action</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="blue white--text pr-3" elevation="0" @click="onPressExport()"><v-icon class="mr-2">mdi-clipboard-check-outline</v-icon>Export</v-btn>
            </v-card-actions>
        </v-card>

        <utils-map-save-action-pop-edit ref="utils-map-save-action-pop-edit"></utils-map-save-action-pop-edit>

        <v-card elevation="0" outlined width="100%" class="mt-2 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-card width="100%" elevation="0">
                    <v-card-title>
                        <v-text-field
                            outlined
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            clearable
                            hide-details
                            dense
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            style="width: 100%;"
                            fixed-header
                            :items="getData"
                            v-model="selected"
                            :headers="headers"
                            :search="search"
                            :single-select="false"
                            item-key="uid"
                            hide-default-footer
                            show-select
                            disable-pagination>

                        
                        <template v-slot:item.action="{item}">
                            <div>{{ getActionName(item.action) }}</div>
                        </template>

                        <template v-slot:item.maps="{item}">
                            <div>{{ item.maps.map(m => m.key).join(', ') }}</div>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon
                                            color="green"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mr-1"
                                            @click="onPressEdit(item)">
                                        <v-icon size="22">mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                                <span>Edit</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon
                                           color="red"
                                           v-bind="attrs"
                                           v-on="on"
                                           class="mr-1"
                                           @click="onPressDelete(item)">
                                        <v-icon size="22">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Delete</span>
                            </v-tooltip>
                        </template>

                    </v-data-table>
                </v-card>
            </v-card-actions>
        </v-card>
    </v-card>
</template>

<script>

import UtilsMapSaveActionPopEdit from "@/modules/mutils/views/map-save-action/utils-map-save-action-pop-edit";

import firebase from "firebase";
import {deserialize, serialize} from "serializr";
import {MapSaveAction} from "@/modules/mutils/models/MapSaveAction";


export default {
    name: "utils-map-save-actions-page",
    components: {UtilsMapSaveActionPopEdit},
    data: () => ({
        selected: [],
        data: {},
        search: '',
        headers: [
            {text: 'Key', sortable: true, value: 'key', class: "white blue--text", color: "red"},
            {text: 'Uid', sortable: true, value: 'uid', class: "white blue--text", color: "red"},
            {text: 'Save Action', sortable: true, value: 'action', class: "white blue--text", color: "red"},
            {text: 'Maps', sortable: true, value: 'maps', class: "white blue--text", color: "red"},
            {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width:'15%', align:'end'}
        ],
    }),
    methods:{
        getActionName(key){
            return MapSaveAction.ACTIONS.get(key);
        },

        getList(){
            var self = this;
            let db = firebase.database();
            db.ref("/map_save_actions")
            .once("value")
            .then((snapshot) => {
                let data = Object.values(snapshot.val() || {});
                self.data = data.map(v => deserialize(MapSaveAction, v));
                return Promise.resolve();
            }).catch(() => {
            })
        },
        onPressExport() {
          if (this.selected.length === 0) {
            this.$notify({title: 'Export', text: "select one or more rows", type: "error"});
            return;
          }

          let data = this.selected.map(v => {
            const raw = serialize(MapSaveAction, v);
            return {
              uid: raw.uid,
              key: raw.key,
              action: raw.action,
              maps: (raw.maps || []).map(m => m.code)
            };
          });

          const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
          const url = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = "map_save_actions.json";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.$notify({title: 'Exported', text: "", type: "success"});
        },
        onPressCreate(){
            let data = new MapSaveAction();
            console.log("create:", data.uid, data);
            this.onPressEdit(data);
        },
        saveData(data) {
          let d = serialize(MapSaveAction, data);
          let self = this;
          let db = firebase.database();

          return db.ref("/map_save_actions/" + d.uid).set(d).then(() => {
            self.$notify({title: 'Saved', text: "", type: "success"});
            return self.getList()
          }, (reason) => {
            console.error("Save failed: " + reason);
            self.$notify({title: 'Save failed', text: reason, type: "error"});
          });
        },
        onPressDelete(item){
            this.$confirm("Are you sure?").then(() => {
                let self = this;
                let db = firebase.database();
                console.log("delete:", item.uid);
                return db.ref("/map_save_actions/"+item.uid).set(null).then(() => {
                    self.$notify({title: 'Deleted', text: "", type: "succes"});
                    return self.getList()
                }, (reason) => {
                    console.error("delete explainer failed: " + reason);
                    self.$notify({title: 'Deleted', text: reason, type: "fail"});
                });
            }).catch(() => {})
        },
        onPressEdit(item){
            let self = this;
            let origin = JSON.stringify(serialize(MapSaveAction, item))
            this.$refs['utils-map-save-action-pop-edit'].show(item,function (model) {
                let edited = JSON.stringify(serialize(MapSaveAction, model))
                if (edited == origin){
                    console.log("no changes");
                    return;
                }
                self.saveData(model);
            })
        },
    },
    computed:{
        winsize() {
            return window.app.winsize;
        },
        getData(){
            console.log(Object.values(this.data));
            return Object.values(this.data);
        }
    },
    created() {
        this.getList();
    }

}
</script>

<style scoped>
.scroll {
    overflow-y: scroll
}
</style>